export enum TwoFactorType {
    Code = 'CODE',
    Totp = 'TOTP',
    Push = 'PUSH',
}

export interface TwoFactor {
    type: TwoFactorType;
    secondsUntilNextSend?: number;
    pushExternalAccessToken?: string;
    pushRedirectUrl?: string;
}
